import React, { Component } from 'react';
import PropTypes from "prop-types";

class LoaderTekstWithTimeout extends Component {
    constructor(props) {
        super(props);

        this.timer = null;

        this.state = {
            hidden: true
        };
    }

    componentWillMount() {
        this.timer = setTimeout(() => {
            this.setState({ hidden: false });
        }, this.props.wait);        
    }

    componentWillUnmount(){
        if (this.timer) {
            clearTimeout(this.timer);
        } 
    }

    render() {
        const hidden = this.state.hidden;

        return (hidden ? null : <div style={{backgroundColor: "white", color: "black"}}>
            <br /><br />
			Even geduld aub.<br />
			Het verwerken van uw gegevens vereist heel wat bewerkingen achter de schermen.<br />
			Dit kan enkele minuten duren.<br /><br /><br />
		</div>);
    }
}

LoaderTekstWithTimeout.propTypes = {
    wait: PropTypes.number
};

export default LoaderTekstWithTimeout;